<template>
  <div ref="container">
    <a-modal :title="title" :width="800" :visible="visible" :maskStyle="{'top':'93px','left':'154px'}" @ok="handleOk" @cancel="handleCancel" okText="确认绑定" cancelText="关闭" style="top:10%;height: 80%;">
      <div class="table-page-search-wrapper">
        <a-form layout="inline" @keyup.enter.native="searchQuery">
          <a-row :gutter="24">
            <a-col :md="8" :lg="6"  :sm="24">
              <a-form-item label="登录名称">
                <a-input placeholder="请输入登录名称" v-model="queryParam.loginName"></a-input>
              </a-form-item>
            </a-col>
            <a-col :md="8" :lg="6"  :sm="24">
              <a-form-item label="用户名">
                <a-input placeholder="请输入用户名" v-model="queryParam.userName"></a-input>
              </a-form-item>
            </a-col>
            <a-col :md="8" :lg="6"  :sm="24">
              <a-button type="primary" @click="searchQuery">查询</a-button>
              <a-button style="margin-left: 8px" @click="searchReset">重置</a-button>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <a-table :dataSource="dataSource" :pagination="pagination" :columns="columns" :loading="loading" :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }">

      </a-table>
    </a-modal>
  </div>
</template>
<script>
import { getuserApi, editSupplier } from '@/api/api'
export default {
  name: 'AccountListModel',
  data() {
    return {
      title: '绑定账号',
      visible: false,
      value: '',
      model: {},
      selectedRowKeys: [],
      queryParam: {},
      pagination: {
        current: 1,
        pageSize: 10,
        onChange: this.handlePageChange,
      },
      dataSource: [],
      loading: false,
      columns: [
        {
          title: '登录名称',
          dataIndex: 'loginName',
          width: 100,
        },
        {
          title: '用户姓名',
          dataIndex: 'username',
          width: 100,
        },
        {
          title: '角色',
          dataIndex: 'roleName',
          width: 100,
        },
      ],
    }
  },
  created() {},
  methods: {
    async getlist() {
      this.loading = true
      let params = {
        search: this.queryParam,
        currentPage: 1,
        pageSize: 10,
      }
      const res = await getuserApi(params)
      console.log(res, 'res')
      if (res.code == 200) {
        this.dataSource = res.data.rows
        this.loading = false
      } else {
        this.$message.error(res.data || res.msg)
        this.loading = false
      }
    },

    onSelectChange(selectedRowKeys, selectionRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectionRows = selectionRows
      console.log(selectedRowKeys, 'e---')
      console.log(selectionRows, '数据')
    },
    async add(e) {
      console.log(e, 'e122')
      if (e) {
        this.form = e
      }
      this.visible = true
      this.pagination.current = 1
      // this.getlist()
      // this.loading = true

      // const res = await getSerNumbers({ id: e.id })
      // console.log(res, 'res')
      // if (res.code == 100) {
      //   this.loading = false
      //   this.dataSource = res.data.map((it) => {
      //     return { code: it }
      //   })
      // } else {
      //   this.$message.error(res.data || res.msg)
      //   this.loading = false
      // }
    },
    Bindaccount() {
      console.log('123')
    },
    searchQuery() {
      this.getlist()
    },
    searchReset() {
      this.queryParam = {}
      this.dataSource = []
      // this.getlist()
    },
    close() {
      this.$emit('close')
      this.visible = false
    },
    async handleOk() {
      // 触发表单验证
      if (this.selectedRowKeys.length > 1) return this.$message.warning('只能绑定一个账号信息')
      this.form.userId = this.selectionRows[0].id
      console.log(this.form, 'form')
      const res = await editSupplier(this.form)
      console.log(res, 'res')
      if (res.code == 200) {
        this.$message.success('绑定账号成功')
        this.handleCancel()
        this.$emit('change', this.selectionRows)
      } else {
        this.$message.error(res.data || res.msg)
      }
    },
    handleCancel() {
      this.close()
    },
    handlePageChange(page, pageSize) {
      console.log(page, 'page')
      console.log(pageSize, 'pageSize')
      this.pagination.current = page
    },
  },
}
</script>

<style scoped>
.box {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}
</style>